const messages: Record<string, string> = {
  BC101: "この操作を行う権限がありません",
  BC102: "値が変わっています。最新の状態を読み直しました",
  BC103: "入力内容が正しくありません",
  BC104: "確認できる値がありません",
};

export function fieldCheckErrorMessage(code?: string): string {
  return code && Object.prototype.hasOwnProperty.call(messages, code)
    ? messages[code]
    : "確認の状態を更新できませんでした";
}
